import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input, OnChanges, OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Location } from '@k2/common/entities-state/types';
import { LocationSelectorConfig } from '@k2/common/locations/components/locations-selector/locations-selector.component';

@Component({
  selector: 'location-filter',
  templateUrl: 'location-filter.component.html',
  styleUrls: ['location-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    '[style.width]': 'size'
  }
})
export class LocationFilterComponent implements OnChanges{
  @Input() control: UntypedFormControl;
  @Input() regionId: number;
  @Input() size: string = '200px';
  @Input() placeholder = 'Search city';
  @Input() multiple = false;
  @Output() onChange = new EventEmitter<number | number[] | null>();

  selected: Location[] = [];
  selectedCountry: number;
  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.regionId && changes.regionId.currentValue) {
      this.selectedCountry = parseInt(changes.regionId.currentValue);
    }
  }

  get config(): LocationSelectorConfig {
    return {
      multiple: this.multiple,
      placeholder: this.placeholder
    };
  }

  update(selected: Location[]) {
    this.selected = selected;
    const value = this.multiple
      ? selected.map(loc => loc.id)
      : (selected.length > 0 ? selected[0].id : null);

    this.control.patchValue(value);
    this.onChange.emit(value);
    this.cdr.detectChanges();
  }
}
